// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".player-container[data-v-1ccb7d5c]{height:100%;width:100%;display:flex;justify-content:center;align-items:center;flex-direction:column}.player-container .player[data-v-1ccb7d5c]{height:100%;width:100%;max-height:100%!important;overflow:hidden}", ""]);
// Exports
module.exports = exports;
